module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/html/9780292798489_08_ch1"
    }
  }, [_vm._v("BACKGROUND AND PROSPECT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_10_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I. SCIENCE AND REALITY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_11_ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II. AUTHORITY AND CONSCIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_13_ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III. DEDICATION OR SERVITUDE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_14_ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("APPENDIX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_14_ch5#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. PREMISSES OF SCIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_14_ch5#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. SIGNIFICANCE OF NEW OBSERVATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_14_ch5#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. CORRESPONDENCE WITH OBSERVATION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/9780292798489_15_not",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1041ec0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292798489_05_toc.vue
// module id = 63
// module chunks = 0